<ng-container *transloco="let transloco">
  <div class="relative w-full h-full flex flex-col bg-white">
    <form [formGroup]="signUpGroup" class="relative w-full h-full flex flex-col overflow-y-scroll">
      <div class="name-field">
        <div class="w-full flex flex-col gap-[10px]">
          <div class="label">{{ 'First Name' | transloco }}</div>
          <input class="input" type="text" [placeholder]="transloco('John')" autofocus formControlName="firstName" />
        </div>
        <div class="w-full flex flex-col gap-[10px]">
          <div class="label">{{ 'Last Name' | transloco }}</div>
          <input class="input" type="text" [placeholder]="transloco('Doe')" autofocus formControlName="lastName" />
        </div>
      </div>
      <div class="mt-6 w-full flex flex-col gap-[10px]">
        <div class="label" [ngClass]="{ 'text-black/40': signUpGroup.controls['email'].errors, 'text-black': !signUpGroup.controls['email'].errors }">
          {{ 'Email' | transloco }}
        </div>
        <input class="input" type="email" placeholder="example@example.com" autocomplete="email" autofocus formControlName="email" />
      </div>
      <div class="mt-6 w-full flex flex-col gap-[10px]">
        <div class="label" [ngClass]="{ 'text-black/40': signUpGroup.controls['password'].errors, 'text-black': !signUpGroup.controls['password'].errors }">
          {{ 'Password' | transloco }}
        </div>
        <input class="input" type="password" [placeholder]="transloco('Minimum 8 characters, including a special character')" autocomplete="current-password" autofocus formControlName="password" />
      </div>
      <div class="mt-6 w-full flex flex-col gap-[10px]">
        <div class="label" [ngClass]="{ 'text-black/40': signUpGroup.controls['passwordConfirm'].errors, 'text-black': !signUpGroup.controls['passwordConfirm'].errors }">
          {{ 'Password Confirm' | transloco }}
        </div>
        <input class="input" type="password" [placeholder]="transloco('Re-enter your password')" autocomplete="current-password" autofocus formControlName="passwordConfirm" />
      </div>
      <div class="agree-btn-field">
        <div class="inline-flex items-center">
          <label class="relative flex items-center rounded-full cursor-pointer" htmlFor="checkbox">
            <input
              type="checkbox"
              class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-black transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-900 checked:before:bg-gray-900 hover:border-2"
              id="checkbox"
              formControlName="privacyPolicy" />
            <span class="absolute text-white transition-opacity opacity-0 border-[#D1D1D1] pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" stroke-width="1">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
            </span>
          </label>
        </div>
        <label for="link-checkbox" class="ms-[6px] text-sm font-medium text-gray-900"
          >{{ 'I agree with the' | transloco }} <a class="text-blue-600 dark:text-blue-500 hover:underline">{{ 'terms and conditions' | transloco }}</a
          >.</label
        >
      </div>
    </form>
    <div class="flex-none relative w-full h-[55px] flex flex-row gap-[14px]">
      <button class="w-full h-full flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white disabled:bg-gray-300" (click)="onClickSubmit()" [disabled]="!signUpGroup.valid">{{ 'Sign Up' | transloco }}</button>
      <button class="w-full h-full flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickCancel()">{{ 'Cancel' | transloco }}</button>
    </div>
  </div>
</ng-container>
